import styled from "styled-components";
import React, { useState } from "react";
import HeaderArrow from "../../../components/UI/Icons/HeaderArrow";
import HeaderBullets from "../../../components/UI/Icons/HeaderBullets";
import SwitchButtonOn from "../Buttons/SwitchButtonOn";

const DropDown = styled.div`
  margin-top: 2.4rem;
  width: 100%;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--color-background-white);
  border: 1px solid rgba(61, 30, 92, 0.05);
  box-shadow: var(--shadow-soft);
  transition: box-shadow .25s ease, transform .25s ease;
  &:hover { box-shadow: var(--shadow-medium); }

  .options {
    display: flex;
    justify-content: end;
    padding: 1rem 1.4rem;
    background-color: var(--color-cream);
    border-top: 1px solid rgba(61, 30, 92, 0.06);
    font-style: normal;
  }
  .option-row {
    display: flex;
    align-items: center;
    label {
      margin-right: 1rem;
      font-size: 1.2rem;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: var(--color-text-soft);
    }
  }
`;

const DropDownHeader = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto 50px 30px;
  align-items: center;
  width: 100%;
  margin: auto;
  padding: 1.6rem 2rem;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px) saturate(140%);
  -webkit-backdrop-filter: blur(12px) saturate(140%);
  border-bottom: 1px solid rgba(61, 30, 92, 0.06);
  cursor: ${(props) => (props.showCollapse ? "pointer" : "auto")};

  h2 {
    font-family: 'Fraunces', serif;
    color: var(--color-plum);
    font-size: 1.8rem;
    font-weight: 600;
    letter-spacing: -0.01em;
    margin: 0;
    line-height: 1.25;
  }

  h2 a {
    color: inherit;
    transition: color .2s ease;
    &:hover { color: var(--color-coral); }
  }

  & svg path { transition: fill .2s ease; }
  &:hover h2 { color: var(--color-coral); }
`;

const DropDownBody = styled.div`
  background-color: var(--color-background-white);
  width: 100%;
  margin: auto;
  padding: 2rem 2rem 1.8rem;
  align-items: center;
  overflow: auto;
`;

export default function DropDownComponent({ titleHeader, children, extraOption, showOptions, showCollapse, collapseBody, options, setOptions, bodyStyle, link }) {
  const [collapse, setCollapse] = useState(collapseBody);
  const [optionsView, setOptionsView] = useState(false);

  const toggleCollapse = () => {
    setCollapse(!collapse);
  };

  const toggleSetOptionsView = async (e) => {
    // This part stops the click from propagating to parent onClick event
    if (!e) var e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();

    setOptionsView(!optionsView);
  };

  const updateOptions = async (key, value) => {
    options[key] = value;
    setOptions(options);
  };

  return (
    <DropDown>
      <DropDownHeader onClick={() => showCollapse && toggleCollapse()} showCollapse={showCollapse}>
        {link 
        ? <h2><a href={link}>{titleHeader}</a></h2>
        : <h2>{titleHeader}</h2>
        }
        {extraOption}
        <div onClick={(e) => toggleSetOptionsView(e)}> {showOptions && options && <HeaderBullets />} </div>
        {showCollapse && <HeaderArrow transform={collapse} />}
      </DropDownHeader>
      {!collapse && optionsView && options && (
        <div className="options">
          {Object.keys(options).map((option, idx) => (
            <div className="option-row" key={idx}>
              <label>{option}</label>
              <SwitchButtonOn on={options[option]} onSwitchOn={() => updateOptions(option, true)} onSwitchOff={() => updateOptions(option, false)} />
            </div>
          ))}
        </div>
      )}
      {!collapse && <DropDownBody style={bodyStyle}>{children}</DropDownBody>}
    </DropDown>
  );
}

DropDownComponent.defaultProps = {
  titleHeader: "Header title",
  children: <div>Content</div>,
  showOptions: false,
};
